import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-tax-account-setup',
  templateUrl: './customer-tax-account-setup.component.html',
  styleUrls: ['./customer-tax-account-setup.component.css']
})
export class CustomerTaxAccountSetupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
